import { DndContext, DragEndEvent, DragOverEvent, DragOverlay } from '@dnd-kit/core'
import { createContext, useState } from 'react'
import { CatalogItem } from '../../domain/catalogItem'
import { CatalogTemplateWithItems } from '../../domain/catalogTemplate'
import { AddCatalogItem, AddTemplate, FindOverlayItem, GetViewItemForDraggableCatalogItem, GetViewItemForDraggableTemplate, UpdateSorting } from './CatalogBrowserContext'
import ItemOverlay from './ItemOverlay'

type DragType = {
  catalogItem?: CatalogItem,
  template?: CatalogTemplateWithItems,
  viewItem: any
}

export type Props = React.PropsWithChildren & {
  addCatalogItem: AddCatalogItem
  addTemplate: AddTemplate
  updateSorting: UpdateSorting
  findOverlayItem: FindOverlayItem
  getViewItemForDraggableCatalogItem: GetViewItemForDraggableCatalogItem
  getViewItemForDraggableTemplate: GetViewItemForDraggableTemplate
}

type CatalogItemDndContextData = {
  draggingViewItem?: any
}

export const CatalogItemDndContext = createContext<CatalogItemDndContextData>({})

const TemplateCatalogItemDndContextWrapper = ({addCatalogItem, addTemplate, updateSorting, children, findOverlayItem, getViewItemForDraggableCatalogItem, getViewItemForDraggableTemplate}: Props) => {
  const [draggingCatalogItem, setDraggingCatalogItem] = useState<DragType | undefined>();
  const [dragOverlayData, setDragOverlayData] = useState<any>()
  const [passDraggingItem, setPassDraggingItem] = useState(false)

  const onDragOver = ({active, over}: DragOverEvent) => {
    const catalogItem = active.data.current?.catalogItem
    const template = active.data.current?.template
    
    if (catalogItem && !draggingCatalogItem) {
      setDraggingCatalogItem({
        catalogItem,
        viewItem: getViewItemForDraggableCatalogItem(catalogItem, active.id as string)
      })
    }

    if (template && !draggingCatalogItem) {
      setDraggingCatalogItem({
        template,
        viewItem: getViewItemForDraggableTemplate(template, active.id as string)
      })
    }

    setPassDraggingItem(!!over)
  }

  const onDragEnd = ({active, over}: DragEndEvent) => {
    const catalogItem = draggingCatalogItem?.catalogItem
    const template = draggingCatalogItem?.template
    setDraggingCatalogItem(undefined)
    setDragOverlayData(undefined)
    setPassDraggingItem(false)

    if (!over) {
      return
    }
    
    if (catalogItem) {
      addCatalogItem(catalogItem, over.id as string)
    } else if (template) {
      addTemplate(template, over.id as string)
    } else {
      updateSorting(active.id as string, over.id as string)
    }
  }

  return <DndContext
    onDragEnd={onDragEnd}
    onDragStart={({ active }) => setDragOverlayData(active.data.current)}
    onDragOver={onDragOver}
  >
    <div>
      <CatalogItemDndContext.Provider value={{draggingViewItem: passDraggingItem ? draggingCatalogItem?.viewItem : undefined}}>
      {children}
      </CatalogItemDndContext.Provider>
      <DragOverlay dropAnimation={null} zIndex={9999}>
        {dragOverlayData?.catalogItem &&
          <ItemOverlay item={dragOverlayData.catalogItem} />
        }
        {dragOverlayData?.template &&
          <ItemOverlay item={dragOverlayData.template} />
        }
        {dragOverlayData?.workareaItemId &&
          <ItemOverlay item={findOverlayItem(dragOverlayData.workareaItemId)}/>
        }
        {dragOverlayData?.templateItemId &&
          <ItemOverlay item={findOverlayItem(dragOverlayData.templateItemId)}/>
        }
      </DragOverlay>
    </div>
  </DndContext>
}

export default TemplateCatalogItemDndContextWrapper